import Login from './Login'

export default function AvivaLoginPage(props) {
    return  <Login comp = 'Aviva'/>;
  }